<template>
<div class="container-fluid">
    <div v-for="(section,index) of contents" :key="section.id">
         <div class="row content-row even-section" v-if="index % 2 == 0">
            <div class="col-md-8 whatis-brigadeiro" v-if="section && section.primary">
                <div class="title-bar"></div>
                <h2>{{section.primary.section_title[0].text}}</h2>
                <prismic-rich-text :field="section.primary.section_text"/>
                
            </div> 
            <div class="col-md-4">
                <img v-if="section && section.primary" :src="section.primary.section_image.url" class="img-fluid">
            </div>
        </div>
         <div class="row content-row" v-else >
            <div class="col-md-4 bonjour-order-2">
                <img v-if="section && section.primary" :src="section.primary.section_image.url" class="img-fluid">
            </div>
            
            <div class="col-md-8 whatis-brigadeiro" v-if="section && section.primary">
                <div class="title-bar"></div>
                <h2>{{section.primary.section_title[0].text}}</h2>
                <prismic-rich-text :field="section.primary.section_text"/>
                
            </div> 
        </div>
       
    </div>
</div>
</template>
<script>
export default {
    name: "ContentSection",
    props: ['contents']
}
</script>
<style lang="scss">
.content-row {
    margin-left: 0px;
    margin-right: 0px;
    .col-md-4 {
        padding: 0;
    }
}
.even-section {
    background-color: rgba(248,225,234,0.3);
}
@media (max-width: 680px){
    .bonjour-order-2 {
    -webkit-box-ordinal-group: 3;
    -ms-flex-order: 2;
    order: 2;
}
}

</style>